/**
 * MultiList
 */

import Config from '../Config';
import Util from '../Util';

class MultiList {

	public onLoaded: any;

	public onFailed: any;

	public listData: any[];

	constructor( listData: any[] = [] ) {
		this.onLoaded = new Util.Observer();
		this.onFailed = new Util.Observer();
		this.listData = listData || [];
	}

	public setListData( _listData: any[] ) {
		this.listData = _listData;
	}

	public getListData() {
		return this.listData;
	}

	public get(): any[] {
		if ( !this.listData.length ) {
			return [];
		}

		const _listNewDatas: any = [];
		const _listDatas: any = this.listData;

		for ( let idx = 0, len = _listDatas.length; len > idx; ++idx ) {

			const _listData = _listDatas[ idx ];

			if ( !_listData.data ) {
				_listData.data = {};
			}

			if ( _listData.boardAlias ) {
				_listData.data.previousArticleId = 0;
				_listData.data.size = _listData.data.size || Config.listSize;
			}

			_listNewDatas[ idx ] = {
				url: _listData.url || Config.listMore( _listData.boardAlias ),
				boardAlias: _listData.boardAlias,
				method: _listData.method,
				data: _listData.data,
			};

			if ( _listData.contentType ) {
				_listNewDatas[ idx ].contentType = _listData.contentType;
			}
		}

		const _promise: any = Util.getAll( _listNewDatas );
		_promise.then( ( _listData: any ) => {
			this.onLoaded.emit( _listData );
		}, ( _err: any ) => {
			this.onFailed.emit( _err );
		});
	}
}

export default MultiList;
